import { useState } from "react";
import { useSelector } from "react-redux";

import { dispatch } from "../../state/store";
import {
  setMarket,
  setMarketIso,
  setUserAppTypes,
  setUserMarketFilter,
  setUserMarkets,
  setUserRoles
} from "../../state/ducks";

import { authService } from "../../services";

export const useFetchMandatoryData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);

  const isMandatoryDataFetched = useSelector((store) => store.auth.isMandatoryDataFetched);

  const fetchCallback = async () => {
    try {
      setIsLoading(true);
      setIsSuccess(false);
      setError(null);

      if (!isMandatoryDataFetched) {
        await authService.setAppTypes();
        await authService.setMarkets();
        await authService.setGroups();
        await authService.getAwaitUserGroup();
      }

      setIsSuccess(true);
    } catch (error) {
      setError(error);

      dispatch(setUserAppTypes([]));
      dispatch(setUserMarkets([]));
      dispatch(setMarketIso(null));
      dispatch(setUserMarketFilter(null));
      dispatch(setMarket(null));
      dispatch(setUserRoles([]));
    } finally {
      setIsLoading(false);
    }
  };

  return { fetchCallback, isLoading, isSuccess, error };
};
